import { AloftPrice, UnitRateKey, schUnitRateKey } from '@aloft/toolkit-shared';
import { createSelector } from '@reduxjs/toolkit';

import { selectSubjectPropertyDataEntity } from '../selectSubjectPropertyDataEntity.ts';

export const selectSubjectUnitRates = createSelector(
  [selectSubjectPropertyDataEntity],
  (subjectData) => {
    const unitRates = subjectData?.editableData?.salesComparison?.unitRates;

    return Object.fromEntries(
      schUnitRateKey.options.map((key) => [
        key,
        unitRates?.[key] ? AloftPrice.schema.parse(unitRates[key]) : undefined,
      ]),
    ) as Record<UnitRateKey, AloftPrice | undefined>;
  },
);

export const selectSubjectUnitRateForFeature = createSelector(
  [selectSubjectUnitRates, (state, feature: UnitRateKey) => feature],
  (unitRates, feature) => unitRates[feature],
);
